import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatFormField } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Observable, startWith, map } from 'rxjs';

@Component({
  selector: 'app-autocomplete-field',
  templateUrl: './autocomplete-field.component.html',
  imports: [ MatFormField, MatAutocompleteModule , ReactiveFormsModule,FormsModule,CommonModule,MatInputModule],
  styleUrls: ['./autocomplete-field.component.scss']
})
export class AutocompleteFieldComponent implements OnInit, OnChanges {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() options: any[] = [];
  @Input() displayWith: (option: any) => string = (option) => option?.label || option;
  @Input() disabled: boolean = false;
  @Input() control?: FormControl;
  @Input() errorMessage: string = '';
  @Output() optionSelected = new EventEmitter<any>();

  internalControl: FormControl = new FormControl('');
  filteredOptions: Observable<any[]> = new Observable<any[]>();

  get activeControl(): FormControl {
    return this.control ?? this.internalControl;
  }

  ngOnInit() {
    this.setupFilter();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options']) {
      this.setupFilter();
    }
  }

  setupFilter() {
    this.filteredOptions = this.activeControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterOptions(value))
    );
  }

  private _filterOptions(value: string): any[] {
    const filterValue = (typeof value === 'string' ? value : this.displayWith(value)).toLowerCase();
    return this.options.filter(option => this.displayWith(option).toLowerCase().includes(filterValue));
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent) {
    this.optionSelected.emit(event.option.value?.value);
  }
}
